<template>
  <ActionEdit :disabled="disabled" btn-classes="btn-primary" btn-classes-mobile="text-primary" :to="modifiedTo" />
</template>

<script>

import addForecastToLinksQueryStringMixin from '@/mixins/addForecastToLinksQueryString.js';

export default {
  mixins: [addForecastToLinksQueryStringMixin],
  components: {
    ActionEdit: () => import('@/libs/Table/components/Actions/ActionEdit.vue'),
  },
  props: {
    to: {
      type: Object,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};

</script>
